export type ProductResponse = {
  Data: {
    totalCount: number,
    results: Product[]
  },
  Errors: string[],
  ErrorMessage: string
}

export type PromoCode = {
  Data: [
    {
      PromotionCodeValid: string,
      Currency: string,
      DiscountAmount: number,
      GrossPrice: number
    }
  ],
  Errors: string[],
  ErrorMessage: string
}

export type Product = {
    itemNumber: string,
    name: string,
    productType: string,
    description1: string,
    description2: string,
    description3: string,
    tiers: ProductTier[],
}

export interface ProductDetails {
  productName: string,
  about: string,
  features: string,
  uses: string,
  addl:string;
}

export type ProductTier = {
  tierName: string,
  tierDetails: TierDetails[],
}

export type TierDetails = {
   effectiveDate: string,
   effectiveQuantity: number,
   servicePeriodCode: string,
   pricingPeriodCode: string,
   billingCurrency: string,
   name: string,
   unitPrice: number,
}

export enum TierName {
  MEMBER = "MEMBER",
  NONMBR ="NONMBR"
}

export const ProductImage = {
  'CRBRV':'assets/img/rbrvs.jpg',
};

export const ProductImagesList = [
  {prodCode: 'CRBRV', image: 'assets/img/rbrvs.jpg'},
  {prodCode: 'CER', image: 'assets/img/cer.gif'},
  {prodCode: 'CPTA', image: 'assets/img/cpta.gif'}
];

export const ProductName = {
  'CRBRV':'RBRVS DataManager'
}

export const ProductNames = ['CRBRV']

export interface ProductDtlsForReview {
  itemNumber?: string,
  productName?: string,
  term?: string,
  quantity?: number,
  lineNumber?: number,
  startDate?: string,
  endDate?: string
}

export interface OrderTotalDtls {
  subTotal: number,
  promoDiscount: number,
  tax: number,
  orderTotal: number
}

export interface ProductConfPriceData {
  productName: string,
  price: number,
  quantity: number,
  final: number
}

export interface UserAddress {
  name: string,
  field1: string,
  field2?: string,
  field3?: string,
  cityStateZip: string
}

export interface PaymentDtls {
  method: string,
  cardType: string,
  endingNbr: string,
  month: string,
  year: string
}

export interface ProductDtls {
  quantity: number,
  servicePeriodCode: string,
  prodName?: string,
  currentSubStartDate ?: string,
  currentSubExpDate ?: string,
  isRenewal ?: boolean,
  agreementId ?: string,
  renewalStartDate ?: string
}

export interface CreateOrderRequest {
  Username: string,
  OrderSourceCode: string,
  BillTo: CreateOrderAddr,
  ShipTo: CreateOrderAddr,
  Lines: CreateOrderLine[],
  InstallmentBillingCode: string,
  FreeShipping: boolean,
  DiscountPercent: number,
  PurchaseOrderNumber: string,
  PromotionCode: string,
  CurrencyCode: string
}

export interface CreateOrderAddr {
  CustomerNumber: string,
  AddressCode: string
}

export interface CreateOrderAccess {
  AgreementType: string,
  PriceCode: string,
  ServicePeriodCode: string,
  IsUsageBased: boolean,
  Participants: Participant[],
  IsEulaAccepted: boolean,
  OrderBy: CreateOrderAddr
}

export interface Participant {
  CustomerNumber: string
}

export interface CreateOrderLine {
  ItemNumber: string,
  Quantity: number,
  PromotionCode: string,
  PromotionChoiceCode: string,
  PriceCode: string,
  ShipTo: CreateOrderAddr,
  Access: CreateOrderAccess
}

export interface UpdateOrderRequest {
  LineUpdates: LineUpdate[]
}

export interface LineUpdate {
  ItemNumber: string,
  Quantity: number,
  PromotionCode? : string
}

export interface RenewOrderRequest {
  AgreementId: string,
  OrderSource: string,
  RateCode: string,
  Quantity: number,
  BillTo: CreateOrderAddr,
  PromotionCode ?: string
}
